import React, { useEffect, useState, useMemo } from "reactn";
import { Table, Button, Input, Modal, Form, Row } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, collection, getDocs, deleteDoc } from 'firebase/firestore';
import { EditOutlined, Loading3QuartersOutlined, VideoCameraOutlined, PhoneOutlined } from "@ant-design/icons";
import { StreamSessionPicker } from '../components';
import axios from 'axios';
import FlexSearch from 'flexsearch';

FlexSearch.registerMatcher({
    "ç": "c", "ş": "s", "ı": "i", "ö": "o", "ğ": "g", "ü": "u"
});

const Users = (props) => {
    const { Search } = Input;
    let [data, setData] = useState([]);
    let [user, setUser] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);
    let [search, setSearch] = useState("");
    let [sessionId, setSessionId] = useState(0)
    let [sessionModal, setSessionModal] = useState(null)
    let [sessionModalUser, setSessionModalUser] = useState(null)

    let handleTableChange = async () => {
        get();
    }

    let fx = useMemo(() => {
        if (user.length > 0) {
            let f = new FlexSearch("match", {
                doc: {
                    id: "id",
                    field: ["xname", "xsurname"]
                }
            })
            f.add(user.map(x => ({ ...x, xname: x.name ? x.name.toLocaleLowerCase("tr") : "", xsurname: x.surname ? x.surname.toLocaleLowerCase("tr") : "" })))
            return f
        }
    }, [user])

    let get = async () => {
        if (search === "") {
            const userRef = collection(firebaseDb, 'users');
            let userSnapshot

            userSnapshot = await getDocs(userRef);
            const userList = userSnapshot.docs.map((doc) => {
                return {
                    id: doc.id,
                    ...doc.data()
                }
            });
            setTotalCount(userList.length);
            setUser(userList)
            setData(userList);
        }
        else {
            let result = fx.search(search.toLocaleLowerCase("tr"))
            setTotalCount(result.length);
            setData(result);
        }
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    useEffect(() => {
        get();
    }, [search]);

    let deleteRow = async (item_id) => {
        await deleteDoc(doc(firebaseDb, "users", item_id));
        let newData = data.filter(el => el.id !== item_id);
        setData(newData)
    }

    let startRecord = async () => {
        const win = window.open("https://futurelive-web.eventapp.app/?se=" + sessionId.sessionId, "_blank");
        win.focus();
        setSessionModal(null)
    }

    let call = async (data) => {
        setSessionModalUser(null)
        const article = { sessionId: sessionId.sessionId, user: data };
        let userCall = await axios.post("https://futurelive-api.eventapp.app/rest/call", article).then(resp => {
            return resp.data.opentokSessionId
        });
        get()
    }

    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'profileImageUrl',
            key: 'profileImageUrl',
            width: 100,
            render: (profileImageUrl, record) => {
                return (
                    <div style={{ width: '100px' }}>
                        <img src={profileImageUrl ? profileImageUrl : "https://futurelive-api.eventapp.app/files/avatar.png"} style={{ width: '100%' }} />
                    </div>
                )
            }
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
            width: 150,

        },
        {
            title: 'Soyadı',
            dataIndex: 'surname',
            key: 'surname',
            width: 150,

        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            width: 150,

        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Row className="gap-8" size="small">
                    <Link to={"/users/edit/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Bilgiler</Button>
                    </Link>
                    {/* <Popconfirm
                        onConfirm={() => deleteRow(record.id)} title="Silmeyi Onaylıyor musunuz?"
                        okText="Onayla" cancelText="Vazgeç">
                        <Button type="danger" className="button4" icon={<DeleteOutlined />}>
                            Sil
                        </Button>
                    </Popconfirm> */}
                    <Button className="button-consultant" onClick={() => setSessionModalUser(record)} icon={<PhoneOutlined />}>Görüşmeye Ekle</Button>
                </Row>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Kullanıcılar"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Button className="button4" type="light" onClick={() => setSessionModal(true)} icon={<VideoCameraOutlined />} size="large">Görüşme Başlat</Button>
                </div>
            </div>
            <div className="table-wrap">
                <Search placeholder="isim" onChange={(v) => { setSearch(v.target.value) }} />
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
            {sessionModal &&
                <div>
                    <Modal
                        title={"Yayın Seç"}
                        visible={true}
                        onOk={() => startRecord()}
                        onCancel={() => setSessionModal(null)}>
                        <Form.Item label="Yayın" >
                            <StreamSessionPicker record={sessionId} setRecord={setSessionId} name="sessionId" />
                        </Form.Item>
                    </Modal>
                </div>
            }
            {sessionModalUser &&
                <div>
                    <Modal
                        title={"Yayın Seç"}
                        visible={true}
                        onOk={() => call(sessionModalUser)}
                        onCancel={() => setSessionModalUser(null)}>
                        <Form.Item label="Yayın" >
                            <StreamSessionPicker record={sessionId} setRecord={setSessionId} name="sessionId" />
                        </Form.Item>
                    </Modal>
                </div>
            }
        </div>
    );
};

export default Users;
